import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';
import FeedbackStudio from '@/components/studio/FeedbackStudio';
import { auth } from '@/integrations/firebase/client';
import { onAuthStateChanged } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { validateCheckoutSession } from '@/lib/firebase-functions';

export default function Feedbacks() {
  const { t } = useTranslation();
  const [uid, setUid] = useState<string | null>(auth.currentUser?.uid ?? null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => onAuthStateChanged(auth, (u) => setUid(u?.uid ?? null)), []);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const sessionId = queryParams.get('session_id');

    if (sessionId) {
      // Muestra un toast de procesamiento inmediato
      const promise = validateCheckoutSession({ sessionId });

      toast.promise(promise, {
        loading: t('feedbacks.payment.processing'),
        success: (data) => {
          if (data.data.payment_status === 'paid') {
            return t('feedbacks.payment.success');
          } else {
            return t('feedbacks.payment.pending');
          }
        },
        error: (err) => t('feedbacks.payment.error'),
      });

      // Limpia la URL
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate, t]);

  return (
    <main className="bg-gradient-to-b from-background to-secondary/40">
      <Helmet>
        <title>{t('feedbacks.helmet.title')}</title>
        <meta name="description" content={t('feedbacks.helmet.description')} />
        <link rel="canonical" href={window.location.origin + '/feedbacks'} />
      </Helmet>
      <section className="w-full h-[calc(100vh-4rem)] overflow-hidden p-0">
        {!uid ? (
          <Card className="shadow m-6">
            <CardContent className="py-10 text-center text-muted-foreground">
              {t('feedbacks.signin')}
            </CardContent>
          </Card>
        ) : (
          <FeedbackStudio uid={uid} />
        )}
      </section>
    </main>
  );
}
